document.addEventListener('DOMContentLoaded', () => {
  const trigger = document.querySelector('a[title="Ordering Process"]');

  if (trigger) {
    trigger.addEventListener('click', (e) => {
      e.preventDefault();

      const accordionGroup = document.querySelector('[data-group-type="accordion-group"]');
      if (!accordionGroup) return;

      const accordions = accordionGroup.querySelectorAll('[data-block-type="accordion"] details');

      for (const details of accordions) {
        const label = details.querySelector('.accordion__toggle span:first-child');
        if (label && label.textContent.trim() === 'How to Order') {
          if (!details.open) {
            details.querySelector('summary').click();
          }
          details.scrollIntoView({ behavior: 'smooth', block: 'start' });
          break;
        }
      }
    });
  }
});